import styled from "styled-components"
import { DashboardLayout } from "../../components/layouts"
import { COLORS, avatars } from "../../constants"
import { Row, Col } from "reactstrap"
import { CustomButton, SelectGamesModal, Modal, Refer, SelectTrialGamesModal } from "../../components"
import { Switch, Route, Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import MyResults from "./MyResults"
import TryAgain from "./TryAgain"
import LevelGamesResults from "./LevelGamesResults"
import TryAgainGames from "./TryAgainGames"
import Camera from "../../assets/images/camera.svg"

import refer from "../../assets/images/refer.svg"
import axios from "axios"

const StyledDashboardMenu = styled.ul`
    border-bottom: 6px solid ${COLORS.light_blue};
    height: 36px;
`;
const StyledLink = styled(NavLink)`
    display: block;
    color: ${props => props.tabactive ? ` ${COLORS.text_dark_blue}` : `${COLORS.light_blue}`};
    border-bottom: ${props => props.tabactive ? `6px solid ${COLORS.text_dark_blue}` : ""};
    transition: color 0.2s ease-in;
    padding-bottom: 5px;
    margin-right: 10px;
    font-size: 17px;
    &:hover{
        color: ${props => props.tabactive ? ` ${COLORS.text_dark_blue}` : `${COLORS.light_blue}`};
        text-decoration: none;
        border-bottom: 6px solid ${COLORS.text_dark_blue};
    }
`;
const StyledAvatarContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    justify-content: center;
`;
const StyledImage = styled.img`
    cursor: pointer;
    transition: all 0.2s;

    &:hover{
        transform: scale(0.9)
    }
`;
const StyledCamera = styled.div`
    position: absolute;
    right: 0; 
    bottom: 2px; 
    background-color: white; 
    border-radius: 50%; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    width: 30px; 
    height: 30px;
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    cursor: pointer;
`;

const StyledPlaceholder = styled.div`
    cursor: pointer;
    width: 100px;
    height: 100px;
`;

const StyledCapacityCircle = styled.div`
   width: 25px;
   height: 25px;
   position: absolute;
   top: -10px;
   border: 3px solid #f5f5f5;
   right: -7px;
   font-size: 13px;
   background-color: red;
   color: white;
   display: inline-block;
   border-radius: 50%;
   display: flex;
   justify-content: center;
   align-items: center;
`;
function ChildDashboard(props) {
    const api = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const userRole = useSelector(state => state.auth.userRole)
    const user = useSelector(state => state.auth.user.user)
    const [wordsLearned, setWordsLearned] = useState(0);
    const [toggleActive, setToggleActive] = useState(true);
    const [modalVisible, setModalVisible] = useState(false);
    const [avatarModalVisible, setAvatarModalVisible] = useState(false);
    const [trialModalVisible, setTrialModalVisible] = useState(false);
    const [avatarID, setAvatarID] = useState(-1);
    const [practiceShown, setPracticeShown] = useState(false)
    const [referVisible, setReferVisible] = useState(false);
    const [bucketCapacity, setBucketCapacity] = useState(0);

    useEffect(async () => {
        const response = await axios.get(`${api}/cp/get_avatar/${user.pupil_id}`);
        const data = response.data;
        setAvatarID(data.avatar_id)

    }, [])

    useEffect(async () => {
        const response = await axios.get(`${api}/cp/total_words/${user.pupil_id}`);
        const data = response.data;
        setWordsLearned(data.total_words_learned)


    }, [])
    useEffect(async () => {
        const response = await axios.get(`${api}/ts/cp_retry_capacity/${user.pupil_id}`);
        const data = await response.data;

        setBucketCapacity(data.total_questions);
    }, [])

    const onCloseClick = () => {
        setModalVisible(false);
        setAvatarModalVisible(false);
    }
    const updateAvatar = async (id) => {
        setAvatarModalVisible(false);
        const response = await axios.post(`${api}/cp/update_avatar`, { pupil_id: user.pupil_id, avatar_id: id });
        const data = response.data;
        if (data.status_code == 1) {
            setAvatarID(id)
        }
    }
    return (
        <>
            <DashboardLayout parent>
                <Row className="">
                    <Col lg={4} className="mt-2">
                        <div className="styled-card pt-5 pb-4 px-4">
                            <div className="d-flex flex-column align-items-center">

                                {avatarID == -1 ? <StyledPlaceholder /> :
                                    <div style={{ position: "relative", width: "100%", maxWidth: 100 }} onClick={() => setAvatarModalVisible(true)} >
                                        <img src={avatars[avatarID].image} width={100} style={{ cursor: "pointer" }} onClick={() => setAvatarModalVisible(true)} alt="Avatar" />
                                        <StyledCamera>
                                            <img src={Camera} width="20" />
                                        </StyledCamera>
                                    </div>

                                }
                                <h5 className="mt-2" style={{ color: COLORS.text_dark_blue }}>{user.name}</h5>
                            </div>
                            <div className="mt-2 d-flex justify-content-center align-items-center">
                                <span style={{ color: "black", marginRight: 10 }}>Words Learned</span>
                                <span style={{ color: COLORS.text_green, fontSize: 30, marginLeft: 10 }}>{wordsLearned}</span>
                            </div>
                            <CustomButton
                                className="w-100 mt-3 flex-grow-1"
                                bgColor="#FFE500"
                                hover="#DDC600"
                                color="#958600"
                                onClick={() => setTrialModalVisible(true)}
                            >
                                Trial Games
                            </CustomButton>
                            <CustomButton
                                className="w-100 mt-3 flex-grow-1"
                                bgColor={COLORS.orange}
                                hover={COLORS.orange_hover}
                                color={COLORS.dark_orange}
                                onClick={() => setModalVisible(true)}
                            >
                                Play New Game
                            </CustomButton>
                            <CustomButton onClick={() => setPracticeShown(true)} className="w-100 mt-3 flex-grow-1" bgColor={COLORS.green} hover={COLORS.text_green} color={COLORS.text_dark_green}>Practice Zone</CustomButton>
                        </div>

                        <div className="styled-card py-3 px-3 mt-3 d-none d-lg-block" style={{ backgroundColor: "white", cursor: "pointer" }} onClick={() => setReferVisible(true)}>
                            <div className="d-flex justify-content-center flex-wrap align-items-center">
                                <img src={refer} width={30} className="mr-1" />
                                <div className="d-inline-block text-center ml-2">Refer a friend!</div>
                            </div>
                        </div>


                    </Col>
                    <Col lg={8} className="mtop-sm-3">
                        <StyledDashboardMenu className="d-flex list-unstyled">
                            <li>
                                <StyledLink tabactive={typeof (location.pathname.split("/")[2]) == 'undefined' || location.pathname.split("/")[2] == 'results'} onClick={() => setToggleActive(true)} to="/dashboard">My Results</StyledLink>
                            </li>

                            <li style={{ position: "relative" }}>
                                <StyledLink tabactive={location.pathname.split("/")[2] == "try_again"} onClick={() => setToggleActive(false)} to="/dashboard/try_again">Let's Go Again</StyledLink>
                                <StyledCapacityCircle>{bucketCapacity}</StyledCapacityCircle>
                            </li>
                        </StyledDashboardMenu>



                        <Switch>
                            <Route exact path="/dashboard" component={MyResults} />
                            <Route exact path="/dashboard/try_again" component={TryAgain} />
                            {/* <Route exact path="/dashboard/try_again/:levelno" component={TryAgainGames} /> */}
                            <Route exact path="/dashboard/results/:levelno" component={LevelGamesResults} />

                        </Switch>

                    </Col>
                </Row>
            </DashboardLayout>
            <Modal modalVisible={avatarModalVisible} onClose={onCloseClick}>
                <div className="p-3">
                    <h4 className="text-center color-text-green">Change Avatar</h4>
                    <StyledAvatarContainer>
                        {avatars.map((image, i) => {
                            return <StyledImage key={i} src={image.image} width="150" className="m-1 avatar" onClick={() => updateAvatar(i)} />
                        })}
                    </StyledAvatarContainer>
                </div>
            </Modal>
            <Refer visible={referVisible} onClose={() => setReferVisible(false)} />
            {/* <SelectGamesModal modalVisible={trialModalVisible} onClose={() => setTrialModalVisible(false)} containerheight="72%" mode={1} isTellFunctionality={true} /> */}
            <SelectTrialGamesModal modalVisible={trialModalVisible} onClose={() => setTrialModalVisible(false)} containerheight="72%" />
            <SelectGamesModal modalVisible={modalVisible} onClose={onCloseClick} containerheight="72%" mode={3} isTellFunctionality={true} />
            <SelectGamesModal modalVisible={practiceShown} onClose={() => setPracticeShown(false)} mode={2} containerheight="72%" isTellFunctionality={false} />
        </>
    );
}

export default ChildDashboard;